import { ApiError, api } from '@/lib/api-client.ts';

import { type DcRole, dcRolesResponseSchema } from '@/schemas/dc-role.schema.ts';

import { ServiceUrl } from '@/services/ServiceURL.ts';

import { requireCustomerId } from '@/utils/customer-utils.ts';

export const fetchDcInstanceRoles = async (instanceId: string): Promise<DcRole[]> => {
    if (!instanceId) {
        throw new ApiError(400, 'missing instanceId');
    }

    const response = await api.get(ServiceUrl.PRACTITIONER_API_DOMAIN.SECURE_ADMIN.DOC_CIRRUS.ROLES, {
        headers: { customer_id: requireCustomerId() },
        params: { instance_id: instanceId },
    });

    const parsed = dcRolesResponseSchema.safeParse(response.data);
    if (!parsed.success) {
        throw new ApiError(502, 'Invalid doc-cirrus roles response');
    }

    return parsed.data.data;
};
